import { useState, useRef, useEffect } from "react";
import NavbarItem from "./NavbarItem";
import NavbarMobileList from "./NavbarMobileList";
import { INavbarItemListProps } from "./navbarTypes";
import { navLinks } from "./navbarUtils";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { RootState } from "store/store";
import { resetRadarRouteDetail } from "store/actions/radarRouteDetail";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const navlinksPermissionsHelper = [
  { label: "Klub", Id: 139, permission: false },
  { label: "Zajęcia", Id: 284, permission: false },
  { label: "Aktywność", Id: 999, permission: true },
  { label: "Zawodnicy", Id: 133, permission: false },
  { label: "Nabór", Id: 135, permission: false },
  { label: "Trenerzy", Id: 67, permission: false },
  { label: "Rekrutacja trenerów", Id: 138, permission: false },
  { label: "Sklep", Id: 140, permission: false },
  { label: "Personel", Id: 211, permission: false },
  { label: "Teczka", Id: 213, permission: false },
  { label: "System", Id: 291, permission: false },
  { label: "Posty", Id: 379, permission: false },
  { label: "Dostępy", Id: -999, permission: true },
];

const NavbarItemList: React.FC<INavbarItemListProps> = ({
  isExpanded,
  isNavbarOverflowActive,
  height,
}) => {
  const { t } = useTranslation();
  const permissions = useSelector(
    (state: any) => state.permissions.permissions,
  );
  const [expandedItemId, setExpandedItemId] = useState<number | null>(null);

  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [isOverflowActive, setIsOverflowActive] = useState(false);

  const dispatch = useDispatch();

  const handleExpand = (id: number) => {
    setExpandedItemId((prev) => (prev === id ? null : id));
  };
  const academyMerchantStatus = useSelector(
    (state: RootState) => state?.academyMerchantStatusReducer.value,
  );

  const navItemsWithPermissions = navLinks.map((item: any) => {
    const permissionEntry = navlinksPermissionsHelper.find(
      (nav) => nav.label === item.label,
    );

    if (item.label === "Sklep" && !academyMerchantStatus) {
      return {
        ...item,
        permission: academyMerchantStatus
          ? permissions.some((perm: any) => perm.Id === 140)
          : false,
      };
    }

    const hasPermission =
      item.label === "Konspekty" ||
      item.label === "Monitoring" ||
      item.label === "Dostępy" ||
      (permissionEntry
        ? permissions.some((perm: any) => perm.Id === permissionEntry.Id)
        : false);

    return {
      ...item,
      permission: hasPermission,
    };
  });

  const handleUserInfo = () => {
    toast.error(t("common.noPermission"));
  };

  const updatedNavLinks = navLinks.map((item: any) => {
    if (item.label === "Sklep") {
      return {
        ...item,
        permission: academyMerchantStatus,
      };
    }
    const permissionEntry = navlinksPermissionsHelper.find(
      (nav) => nav.label === item.label,
    );

    const hasPermission = permissionEntry
      ? permissions.some((perm: any) => perm.Id !== permissionEntry.Id)
      : true;

    return {
      ...item,
      permission: hasPermission,
    };
  });

  const navItemPermission =
    permissions[0]?.Id === -1 ? updatedNavLinks : navItemsWithPermissions;

  useEffect(() => {
    const checkOverflow = () => {
      const el = scrollContainerRef.current;
      if (el) {
        const hasOverflow = el.scrollHeight > el.clientHeight;
        setIsOverflowActive(hasOverflow);
      }
    };

    checkOverflow();

    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [expandedItemId, permissions]);

  return (
    <div>
      <ScrollContainers
        ref={scrollContainerRef}
        className="hidden md:block relative overflow-y-auto"
        style={{
          // maxHeight: "70vh",
          // borderBottom: "1px solid white",
          // padding: "0 8px 10px 8px",
          // height: "475px",
          boxSizing: "border-box",
          width: "calc(100% + 16px)",
          marginLeft: "-8px",
          // borderBottom: "1px solid",
          // borderImage: "linear-gradient(to right, #b6b4b4, rgb(15, 15, 14)) 1%",
          /* isNavbarOverflowActive ? '394px' : */
          height: (height ?? 0) < 858 ? "364px" : "auto",
          overflowY:
            isOverflowActive && (height ?? 0) < 858 ? "scroll" : "hidden",
        }}
      >
        {navItemPermission.map((item, index) => {
          return (
            <div
              onClick={() => {
                if (item.permission !== undefined && !item.permission) {
                  handleUserInfo();
                }
                dispatch(resetRadarRouteDetail());
              }}
              style={{
                // opacity: !item.permission ? '0.4' : '',
                opacity:
                  item.permission !== undefined
                    ? !item.permission
                      ? "0.3"
                      : ""
                    : "1",
                margin: "4px 0px",
              }}
              key={item.label}
            >
              <div
                style={{
                  // pointerEvents: !item.permission ? 'none' : 'auto'
                  pointerEvents:
                    item.permission !== undefined
                      ? !item.permission
                        ? "none"
                        : "auto"
                      : "auto",
                }}
              >
                <NavbarItem
                  {...item}
                  key={index}
                  isExpanded={expandedItemId === index}
                  onExpand={() => handleExpand(index)}
                />
              </div>
            </div>
          );
        })}
      </ScrollContainers>
      <div>
        <NavbarMobileList isExpanded={isExpanded} />
      </div>
    </div>
  );
};

export default NavbarItemList;

const ScrollContainers = styled.div`
  overflow-y: auto;

  /* WebKit-based browsers (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    width: 1px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgb(156, 176, 196);
    border-radius: 4px;
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgb(156, 176, 196) transparent;
`;
